


























































import { Vue, Component } from 'vue-property-decorator'
import UserHeader from '@/components/common/layout/UserHeader.vue'

@Component({
  name: 'ComponentsPage',
  components: {
    UserHeader
  }
})

export default class ComponentsPage extends Vue {
  value = null
  multiselect = []
  options = [
    { name: 'Vue.js', language: 'JavaScript' },
    { name: 'Rails', language: 'Ruby' }
  ]
}
